module.exports = __webpack_public_path__ + "img/LOGOOO.3eacd208.png";